import { useMediaQuery } from 'react-responsive';
import defaultTheme from 'tailwindcss/defaultTheme';

const useLargeScreenMediaQuery = () => {
  const isLargeScreen = useMediaQuery({ minWidth: defaultTheme.screens.lg });
  return isLargeScreen;
};

export default useLargeScreenMediaQuery;
